import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import BankAccountFactory from "../../Entity/Factories/BankAccountFactory";
import { BankAccountInterface } from "../../Entity/Entities/BankAccount/BankAccountInterface";

class BankAccountCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const bankAccount: BankAccountInterface = BankAccountFactory.create(props.res);
    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_SUCCESS,
      payload: {
        bankAccount: bankAccount
      }
    });
  }

}

export { BankAccountCreate };
